import { gql } from "@apollo/client"

export const GET_PEOPLE_WITH_SESSION_COUNT = gql`
query getPeopleWithSessionCount( $id:UUID,$query:String,$first:Int, $after:String) {
  personStatsPerCompany (id:$id,query:$query, first:$first, after:$after){
   pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges{
    node{
    id
    firstName
    lastName
    expired
    role{
      name
      normalizedName
    }
    workLists{
      status
    }
    singleStudents{
        id
        firstName
        lastName
        locationId
        references
    }
    totalCompleteSessions
    lastRunSession
    locations {
      edges{
        node{
          id
          name
          }
        }
      }}}
  }
}
`